import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { arrayOf, func, shape, string } from 'prop-types';
import { Icon } from '@magalu/stereo-ui-icons';
import { AccordionContainer, AccordionContent, AccordionHeader, GroupTitleLink, LinkItem, ToggleButton } from './SeoCategoryTreeLinksMobile.styles';
var SeoCategoryTreeLinksMobile = function SeoCategoryTreeLinksMobile(_ref) {
  var groups = _ref.groups,
    onLinkClick = _ref.onLinkClick;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    openGroups = _useState2[0],
    setOpenGroups = _useState2[1];
  var toggleGroup = function toggleGroup(href) {
    return setOpenGroups(function (prev) {
      return _extends({}, prev, _defineProperty({}, href, !(prev == null ? void 0 : prev[href])));
    });
  };
  return React.createElement(React.Fragment, null, groups.map(function (_ref2) {
    var href = _ref2.href,
      label = _ref2.label,
      subtree = _ref2.subtree;
    return React.createElement(AccordionContainer, {
      key: href
    }, React.createElement(AccordionHeader, null, React.createElement(GroupTitleLink, {
      href: href,
      onClick: function onClick(e) {
        return onLinkClick(e, href);
      }
    }, label), (subtree == null ? void 0 : subtree.length) > 0 && React.createElement(ToggleButton, {
      type: "button",
      open: openGroups == null ? void 0 : openGroups[href],
      onClick: function onClick() {
        return toggleGroup(href);
      },
      "aria-expanded": !!(openGroups == null ? void 0 : openGroups[href]),
      "aria-label": "".concat((openGroups == null ? void 0 : openGroups[href]) ? 'Fechar' : 'Abrir', " ").concat(label),
      "data-testid": "toggle-group-".concat(href)
    }, React.createElement(Icon, {
      name: "ChevronDown",
      width: 16,
      height: 16
    }))), (subtree == null ? void 0 : subtree.length) > 0 && React.createElement(AccordionContent, {
      open: !!(openGroups == null ? void 0 : openGroups[href])
    }, subtree.map(function (link) {
      return React.createElement(LinkItem, {
        key: link.href,
        href: link.href,
        onClick: function onClick(e) {
          return onLinkClick(e, link.href);
        }
      }, link.label);
    })));
  }));
};
process.env.NODE_ENV !== "production" ? SeoCategoryTreeLinksMobile.propTypes = {
  groups: arrayOf(shape({
    href: string,
    label: string,
    subtree: arrayOf(shape({
      href: string,
      label: string
    }))
  })),
  onLinkClick: func
} : void 0;
SeoCategoryTreeLinksMobile.defaultProps = {
  groups: [],
  onLinkClick: function onLinkClick() {}
};
export default SeoCategoryTreeLinksMobile;